import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const TableHeader: FC = () => {
	const { t } = useTranslation();
	return (
		<thead className="t_head">
			<tr data-testid="head-row">
				<th>{t('general.id')}</th>
				<th>{t('listBuilder.printTemplate')}</th>
				<th>{t('general.sports')}</th>
				<th className="text_center">{t('general.default')}</th>
				<th></th>
			</tr>
		</thead>
	);
};
